module.exports = __webpack_public_path__ + "static/assets/5ae6eb3491ba7629cf91e7905dff6171.png";